import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Loader from '../../component/Loader';

const useHandleToken = () => {

    const navigate = useNavigate();
    const [isRedirecting, setIsRedirecting] = useState(false);

    useEffect(() => {

        setIsRedirecting(true);

        const params = new URLSearchParams(window.location.hash.split('?')[1]);

        const transaction_id = params.get('txnid');
        const exam_id = params.get('examid');
        const discipline_id = params.get('discipline');
        const type = params.get('action');
        const scrutiny = params.get('scrutiny');
        
        // const msage = params.get('status');

        localStorage.setItem('transaction_id', transaction_id);
        localStorage.setItem('exam_id', exam_id);
        localStorage.setItem('discipline_id', discipline_id);
        localStorage.setItem('type', type);
        localStorage.setItem('scrutiny',scrutiny );
        



        if (transaction_id && exam_id) {

            setTimeout(() => {
                const baseUrl = window.location.origin;
                const additionalPath = '/#/payment';
                const newUrl = baseUrl + additionalPath;
                window.location.href = newUrl;
            }, 1000);

        }
        else {

            localStorage.setItem('validationerror', 'login failed');
            const baseUrl = window.location.origin;
            const additionalPath = '/#/studentrevalview';
            const newUrl = baseUrl + additionalPath;
            window.location.href = newUrl;

        }

    }, [navigate]);

    return isRedirecting;
};


export default function StudentPaymentresponse() {
    const isRedirecting = useHandleToken();

    return isRedirecting ? (
        // <div className='body23'>
        //     <div className="container23">
        //         <div className="login-box23" style={{ minHeight: "50%", alignContent: "center" }}>
        //             <div className="card-body d-flex justify-content-center align-items-center" >
        //                 <div className="containeranimate">
        //                     <div className="dot"></div>
        //                     <div className="dot"></div>
        //                     <div className="dot"></div>
        //                     <div className="dot"></div>
        //                     <div className="dot"></div>
        //                     <div className="dot"></div>
        //                     <div className="dot"></div>
        //                     <div className="dot"></div>
        //                 </div>
        //             </div>

        //         </div>
        //     </div>
        // </div>
        <Loader />
    ) : null;
}
